import { rootApiFlagWithoutToken } from '..';
import { Country, ListResponse, PaginationRequest } from '../CommonApi/types';

export const CommonApiWithoutToken = rootApiFlagWithoutToken.injectEndpoints({
  endpoints: builder => ({
    getAllCountries: builder.query<ListResponse<Country>, PaginationRequest>({
      query: (arg: PaginationRequest) => {
        const { size, page, query } = arg;
        return {
          url: `/_search/countries`,
          params: { size, page, query },
        };
      },
      transformResponse: (data: Country[], meta) => {
        return {
          total: Number(meta?.response?.headers.get('X-Total-Count')!),
          data,
        };
      },
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetAllCountriesQuery } = CommonApiWithoutToken;

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useCommonSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
